import React, { Component } from "react";
import QRCode from 'utils/qrcode';
//css
import "./index.less";

class App extends Component {
    componentDidMount(){
        new QRCode(document.querySelector(".qrcode-img"), {
            text: window.location.href,
            width: 200,
            height: 200
        });
    }

    render(){
        return <div className="qrcode-wrap">
            <h2>请长按识别二维码打开小程序</h2>
            <div className="qrcode-img"></div>
        </div>
    }
}

export default App;
